export default {
	default: [''],
	rectangle: ['badge--rectangle']
};
